import React from 'react';
import PropTypes, { any } from 'prop-types';

import MatchSheetHeader from './OfficialPrintComponents/MatchSheetHeader';
import MatchSheetMatchData from './OfficialPrintComponents/MatchSheetMatchData';
import MatchSheetPlayerData from './OfficialPrintComponents/MatchSheetPlayerData';
import MatchSheetRoundData from './OfficialPrintComponents/MatchSheetRoundData';
import MatchSheetScoreData from './OfficialPrintComponents/MatchSheetScoreData';

import { shouldDisplayWinnerAndScoreData } from '../../utils/matchScorePrintPage';

import styles from './officialTwoThree.scss';

const OfficialTwoThree = ({ hasBreak, match }) => {
    const shouldDisplayWinnerScoreData = shouldDisplayWinnerAndScoreData(match);

    return (
        <div className={hasBreak ? styles.officialBreakAfter : styles.official}>
            <div className={styles.officialUp}>
                <MatchSheetHeader
                    match={match}
                />
                <MatchSheetMatchData
                    match={match}
                    showReferee
                />
                <div className={styles.data}>
                    <MatchSheetPlayerData
                        match={match}
                        positionType="positionOne"
                    />
                    {!shouldDisplayWinnerScoreData && (
                        <MatchSheetRoundData
                            roundsToDisplay={3}
                            match={match}
                        />
                    )}
                </div>
                <MatchSheetScoreData
                    match={match}
                />
                <div className={`${styles.data} ${styles.invert}`}>
                    <MatchSheetPlayerData
                        match={match}
                        positionType="positionTwo"
                        addTopBorder
                    />
                    {!shouldDisplayWinnerScoreData && (
                        <MatchSheetRoundData
                            roundsToDisplay={3}
                            match={match}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default OfficialTwoThree;

OfficialTwoThree.propTypes = {
    hasBreak: PropTypes.bool,
    match: PropTypes.objectOf(any).isRequired,
};

OfficialTwoThree.defaultProps = {
    hasBreak: true,
};
